import { render } from "./password-recovery.vue?vue&type=template&id=1af64a9a&scoped=true"
import script from "./password-recovery.vue?vue&type=script&lang=js"
export * from "./password-recovery.vue?vue&type=script&lang=js"

import "./password-recovery.vue?vue&type=style&index=0&id=1af64a9a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af64a9a"]])

export default __exports__